<div class="toggle">
  <div class="toggle-item">
    <dmb-button
      type="button"
      [disabled]="disabled()"
      (buttonClick)="selection.set(true)"
      [variant]="getVariant(selection())"
      >{{ labelOn() }}</dmb-button
    >
  </div>
  <div class="toggle-item">
    <dmb-button
      type="button"
      [disabled]="disabled()"
      (buttonClick)="selection.set(false)"
      [variant]="getVariant(!selection())"
      >{{ labelOff() }}</dmb-button
    >
  </div>
</div>
